import { defineComponent } from "vue";
import { getImageBreakpoints } from "./component-library217.mjs";
import { getConfig } from "./component-library2.mjs";
import { addCdnHost } from "./component-library216.mjs";
const _sfc_main = defineComponent({
  props: {
    src: { type: String, required: true },
    srcSm: { type: String, default: null },
    srcMd: { type: String, default: null },
    srcLg: { type: String, default: null },
    srcXl: { type: String, default: null },
    imageClass: { type: String, default: "" },
    imageStyle: { type: String, default: "" },
    alt: { type: String, default: "" },
    // background images are allowed to have no alt.
    height: { type: Number, default: void 0 },
    width: { type: Number, default: void 0 },
    lazy: { type: Boolean },
    format: { type: String, default: "webp" },
    doNotConvert: { type: Boolean },
    sizes: {
      type: String,
      // "sm:100vw md:50vw lg:400px" https://v0.image.nuxtjs.org/components/nuxt-img#sizes
      default: ""
    },
    preload: { type: Boolean }
  },
  emits: ["image-error"],
  head() {
    var _a, _b;
    if (this.preload && ((_a = this.defaultImage) == null ? void 0 : _a.src)) {
      return {
        link: [
          {
            rel: "preload",
            as: "image",
            href: ((_b = this.defaultImage) == null ? void 0 : _b.src) || ""
          }
        ]
      };
    }
    return {};
  },
  computed: {
    imagesBreakpoints() {
      return getImageBreakpoints(this.sizes, {
        xs: this.src || void 0,
        sm: this.srcSm || void 0,
        md: this.srcMd || void 0,
        lg: this.srcLg || void 0,
        xl: this.srcXl || void 0
      });
    },
    sourcesByBreakpoint() {
      const { imageOptimizer } = getConfig() || {};
      if (!this.imagesBreakpoints)
        return [];
      return this.imagesBreakpoints.map(({ src, minWidth, name, defaultWidth, imageWidth }) => {
        const targetImageWidth = imageWidth || defaultWidth || void 0;
        if (!src && (!targetImageWidth || !imageWidth))
          return null;
        if (src && /\.svg/i.test(src)) {
          return {
            name,
            src: addCdnHost(src),
            type: `image/svg`
          };
        }
        if (!src) {
          src = this.getLastSource(name);
          if (!src)
            return null;
        }
        const options = {
          sizes: `${name}:${targetImageWidth}`,
          modifiers: {
            format: this.format
          }
        };
        const convertedSrc = this.doNotConvert || !imageOptimizer ? src : imageOptimizer(src, options).src;
        const isFluid = String(targetImageWidth).endsWith("vw");
        let sizeWithUnit = targetImageWidth;
        if (!isFluid && /^\d+$/.test(String(targetImageWidth))) {
          sizeWithUnit = `${targetImageWidth}px`;
        }
        if (!isFluid && !String(sizeWithUnit).endsWith("px")) {
          return null;
        }
        const cWidth = parseInt(String(sizeWithUnit), 10);
        if (!cWidth) {
          return null;
        }
        return {
          name,
          width: cWidth,
          minWidth,
          media: (minWidth || 0) > 0 ? `(min-width: ${minWidth}px)` : "",
          src: addCdnHost(convertedSrc),
          type: `image/${this.format}`
        };
      }).filter(Boolean);
    },
    defaultImage() {
      var _a;
      return (_a = this.sourcesByBreakpoint) == null ? void 0 : _a[0];
    },
    sourcesWithBreakpointReverse() {
      return [...this.sourcesByBreakpoint].filter((entry) => entry && (entry.minWidth || 0) > 0).sort((a, b) => (b.minWidth || 0) - (a.minWidth || 0));
    }
  },
  methods: {
    getLastSource(name) {
      const index = this.imagesBreakpoints.findIndex((e) => e.name === name);
      for (let i = index; i >= 0; i -= 1) {
        if (this.imagesBreakpoints[i].src)
          return this.imagesBreakpoints[i].src || void 0;
      }
      return void 0;
    }
  }
});
export {
  _sfc_main as default
};
